<template>
  <div class="base-loader-octagon">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#fff" viewBox="0 0 19 19">
      <path ref="path" d="M13.2.5l5.3 5.3v7.4l-5.3 5.3H5.8L.5 13.2V5.8L5.8.5h7.4"/>
    </svg>
  </div>
</template>

<script>
import { TimelineMax, TweenMax, Linear, Power1 } from 'gsap'
import '@/assets/lib/DrawSVGPlugin'
export default {
  mounted () {
    const tl = new TimelineMax({ repeat: -1 })
    TweenMax.to(this.$refs['path'], 1.5, { rotation: 360, transformOrigin: 'center center', ease: Power1.easeInOut, repeat: -1 })
    tl.from(this.$refs['path'], 1.5, { drawSVG: '0% 0%', ease: Linear.easeNone })
    tl.to(this.$refs['path'], 1.5, { drawSVG: '100% 100%', ease: Linear.easeNone })
  }
}
</script>

<style lang="scss" scoped>
svg {
  height: 100%;
  overflow: visible;
  display: block;
}
</style>
